import { RootState } from "app.store";
import { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as signalR from "@microsoft/signalr";
import moment from "moment";
import { fetchProfile } from "states/account/account.slice";
import { OrderModel } from "states/order/order.models";
import { printTheOrder } from "./use-printer";
import { getGlobalThemeSettingApi } from "states/theme-setting/theme-setting.api";
import { message } from "antd";

export function useNotifyOrderPrinter() {
  const dispatch = useDispatch();
  const account = useSelector(
    (state: RootState) => state.account,
    shallowEqual
  );
  const autoPrintOrderOnline = useSelector(
    (state: RootState) => state.globalValue.autoPrintOrderOnline,
    shallowEqual
  );
  const [connection, setConnection] = useState<signalR.HubConnection>();
  const [logoPrint, setLogoPrint] = useState<string>();

  useEffect(() => {
    if (account.isAuthentication && autoPrintOrderOnline) {
      const newconnection = new signalR.HubConnectionBuilder()
        .withUrl(
          process.env.REACT_APP_API_URI + "/signalr-hubs/notify-order-online",
          {
            withCredentials: true,
            accessTokenFactory: async () => {
              if (
                account.token.accessToken &&
                account.token.accessTokenExpires &&
                moment(account.token.accessTokenExpires).isAfter(moment())
              ) {
                return account.token.accessToken;
              }
              await dispatch(fetchProfile());
              return "";
            },
            transport: signalR.HttpTransportType.LongPolling,
          }
        )
        .withAutomaticReconnect({
          nextRetryDelayInMilliseconds: (retryContext) => {
            return 3000;
          },
        })
        .build();
      setConnection(newconnection);
    } else {
      if (connection) {
        connection.stop();
      }
    }
  }, [account.token, account.isAuthentication, autoPrintOrderOnline]);

  useEffect(() => {
    if (connection) {
      connection
        .start()
        .then((result) => {
          message.info("Connect auto print order online successfully");
          connection.on("Notify", (order: OrderModel) => {
            printTheOrder(order, logoPrint ?? "");
          });
        })
        .catch((e) => message.error("Connect auto print order online failed"));
    }
  }, [connection]);

  useEffect(() => {
    getGlobalThemeSettingApi().then((res) => {
      let logoPrint = res.data.value["datalogoprint"]["value"];
      setLogoPrint(logoPrint);
    });

    return () => {
      if (connection) {
        message.info("Stopped auto print order online");
        connection.stop();
      }
    };
  }, []);
}
